
import React from 'react';
import { Box } from 'grommet';

import FilterAttribute from '../common/FilterAttribute';

const FILTER_ATTRIBUTES = [
    {
        id: 'name',
        title: 'Název',
        type: 'text'
    },
    {
        id: 'typ_odrudy',
        title: 'Typ odrůdy',
        type: 'select',
        values: ['moštová', 'stolní']
    },
    {
        id: 'bobule_barva',
        title: 'Barva bobule',
        type: 'select',
        values: ['bílá', 'červená', 'modrá', 'šedá']
    },
    {
        id: 'bobule_velikost',
        title: 'Velikost bobule',
        type: 'select',
        values: ['malá', 'střední', 'velká', 'velmi velká']
    },
    {
        id: 'hrozen_velikost',
        title: 'Velikost hroznu',
        type: 'select',
        values: ['malý', 'střední', 'velký', 'velmi velký']
    },
    {
        id: 'doba_zrani',
        title: 'Doba zrání',
        type: 'select',
        values: ['srpen', 'září', 'říjen']
    },
    {
        id: 'status_odrudy',
        title: 'Status odrůdy',
        type: 'select',
        values: [
            'Historická dosud významná',
            'Historická (stará) ustupující',
            'Historická (stará) krajová',
            'Historická zaniklá',
            'Nová standardní',
            'Nová interspecifická (PIWI)'
        ]
    }
];

const OdrudyFilter = ({attributes, onChange}) => {
    return (
        <Box direction="row" wrap={true} pad={{bottom: '16px'}} >
            {FILTER_ATTRIBUTES.map(item => {
                return (
                    <Box key={item.id} pad="xxsmall" style={{width: '456px'}}>
                        <FilterAttribute
                            filterItem={item}
                            onChange={onChange}
                            value={attributes[item.id]}
                        />
                    </Box>
                );
            })}
        </Box>
    );
};

export default OdrudyFilter;
